import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '../../environments/environment';
import { catchError, tap, switchAll, retryWhen, delay, delayWhen } from 'rxjs/operators';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { SiteService } from './site.service';

@Injectable({
    providedIn: 'root'
})
export class ChatService {
    constructor(private http: HttpClient,
        private siteService: SiteService) { }

    private socket$: WebSocketSubject<any>;
    private messagesSubject$ = new Subject();
    public wsChat$ = new Subject();
    pingTimer;

    public messages$ = this.messagesSubject$.pipe(switchAll(),
        tap(data => {
            clearTimeout(this.pingTimer);
            this.pingTimer = setTimeout(() => {
                this.sendMessage({ type: 'ping' });
            }, 1.5 * 60 * 1000)

        }),
        catchError(e => { throw e }));

    public connect(cfg: { reconnect: boolean } = { reconnect: false }): void {
        if (this.siteService?.siteSetting?.companyId || !this.siteService.features?.chat) return;
        if (!this.socket$ || this.socket$?.closed) {
            this.socket$ = this.getNewWebSocket();
            const messages = this.socket$?.pipe(cfg.reconnect ? this.reconnect : o => o,
                               tap({
                                    error: error => console.log(error),
                                }),
                catchError(_ => EMPTY)
            );
            this.messagesSubject$.next(messages);
        }
    }

    sendMessage(messageData: any) {
        this.socket$?.next(messageData);
    }

    // openConversation(convData) {
    //     this.socket$.next(convData);
    // }

    close() {
        this.socket$?.complete();
        this.socket$ = undefined;
    }

    createChat(params) {
        return this.http.post<any[]>(`${environment.apiUrl}/chat/create`, params);
    }

    getChat(chatId: String) {
        return this.http.get<any[]>(`${environment.apiUrl}/chat/${chatId}`);
    }

    getAllChats() {
        return this.http.get<any[]>(`${environment.apiUrl}/chat`);
    }

    getConversation(params) {
        return this.http.get<any[]>(`${environment.apiUrl}/chat/messages`, { params: params });
    }

    fileUpload(chatId, params) {
        return this.http.post<any>(`${environment.apiUrl}/chat/${chatId}/reply`, params);
    }

    private reconnect(observable: Observable<any>): Observable<any> {
        return observable.pipe(retryWhen(errors => errors.pipe(
            delayWhen(_ => timer(3000)))));
    }

    private getNewWebSocket() {
        let wsUrl = _.replace(environment.apiUrl, 'http', 'ws');
        return webSocket({
            url: `${wsUrl}/ws/`,
            openObserver: {
                next: () => {
                    setTimeout(() => {
                        this.sendMessage({ type: 'ping' });
                    }, 6000);
                }
            },
        });
    }
}

